export const mainCls = 'csa-media-slider';

export default {
  [mainCls]: {
    width: '100%',
    height: '100%',
    transition: 'opacity .15s linear',
    opacity: 1,
    '& .slick-slider': {
      position: 'relative',
      display: 'block',
      boxSizing: 'border-box',
      height: '100%',
      
      '-webkit-user-select': 'none',
      '-moz-user-select': 'none',
      '-ms-user-select': 'none',
      'user-select': 'none',
      '-webkit-touch-callout': 'none',
      '-khtml-user-select': 'none',
      '-ms-touch-action': 'pan-y',
      'touch-action': 'pan-y',
      '-webkit-tap-highlight-color': 'transparent',
    },
    '& .slick-list': {
      position: 'relative',
      display: 'block',
      overflow: 'hidden',
      margin: 0,
      padding: 0,
      height: '100%',
    },
    '& .slick-list:focus': {
      outline: 'none',
    },
    '& .slick-list.dragging': {
      cursor: 'pointer',
      cursor: 'grab',
    },
    '& .slick-slider .slick-track': {
      transform: 'translate3d(0, 0, 0)',
    },
    '& .slick-slider .slick-list': {
      transform: 'translate3d(0, 0, 0)',
    },
    '& .slick-track': {
      position: 'relative',
      top: 0,
      left: 0,
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
      height: '100%',
    },
    '& .slick-track:before': {
      display: 'table',
      content: '""',
    },
    '& .slick-track:after': {
      display: 'table',
      content: '""',
      clear: 'both',
    },
    '& .slick-slide': {
      float: 'left',
      height: '100%',
      minHeight: '1px',
      '& > div': {
        height: '100%',
      },
    },
  },
  [`${mainCls}--zoom`]: {
    '& .slick-slider': {
      '-ms-touch-action': 'auto',
      'touch-action': 'auto',
    },
  },
  [`${mainCls}--hid`]: {
    opacity: 0,
  },
  [`${mainCls}__item`]: {
    width: '100%',
    height: '100%',
  },
  [`${mainCls}__item--flrpl`]: {
    background: '#F0F2F5',
    padding: '48px 0'
  },
}